import { Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ConfigService } from '@app/services/config/config.service';
import { FeatureFlagService } from '@app/services/feature-flag.service';
import { LocalStorageService } from '@app/services/local-storage.service';
import { PetService } from '@app/services/pet.service';
import { ContentService } from 'app-classic/services/content.service';
import { UserAccountService } from 'app-classic/services/user-account.service';
import { LoginFormComponent as NewLoginFormComponent } from '../../../../app/components/user-accounts/login-form/login-form.component';
import { CreateAccountFormComponent } from '../create-account-form/create-account-form.component';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    standalone: false,
})
export class LoginFormComponent extends NewLoginFormComponent {
    constructor(
        private _localStorageService: LocalStorageService,
        private _userAccountService: UserAccountService,
        private _bottomSheet: MatBottomSheet,
        private _contentService: ContentService,
        private _router: Router,
        private _featureFlagService: FeatureFlagService,
        private _petService: PetService,
        private _configService: ConfigService
    ) {
        super(_localStorageService, _userAccountService, _contentService, _router, _featureFlagService, _configService);
    }

    public closeBottomSheet() {
        this._bottomSheet.dismiss();
    }

    public createAccount() {
        this._bottomSheet.open(CreateAccountFormComponent, { disableClose: true });
    }
}
